import apiClient from "@/app/api/client";
import { replaceParams, userEndpoints } from "@/app/api/endpoints";
import type {
	CreateUserRequest,
	MessageData,
	PaginatedResponse,
	PaginationParams,
	SuccessResponse,
	UpdateUserRequest,
	User,
} from "../types";

export const userService = {
	async list(params?: PaginationParams): Promise<PaginatedResponse<User>> {
		const response = await apiClient.get<PaginatedResponse<User>>(userEndpoints.list, { params });
		return response.data;
	},

	async getById(id: string): Promise<User> {
		const url = replaceParams(userEndpoints.getById, { id });
		const response = await apiClient.get<SuccessResponse<User>>(url);
		return response.data.data;
	},

	async create(data: CreateUserRequest): Promise<User> {
		const response = await apiClient.post<SuccessResponse<User>>(userEndpoints.create, data);
		return response.data.data;
	},

	async update(id: string, data: UpdateUserRequest): Promise<User> {
		const url = replaceParams(userEndpoints.update, { id });
		const response = await apiClient.patch<SuccessResponse<User>>(url, data);
		return response.data.data;
	},

	async delete(id: string): Promise<void> {
		const url = replaceParams(userEndpoints.delete, { id });
		await apiClient.delete<SuccessResponse<MessageData>>(url);
	},
};
